import linkifyHtml from 'linkify-html';

const textToLinks = (message) => {
    const text = message.textContent;
    const linkifiedText = linkifyHtml(text, { target: "_blank" });

    message.innerHTML = linkifiedText;
}

export default function () {
    const threadMessages = document.querySelector('.thread-messages');

    if (threadMessages) {
        const messages = threadMessages.querySelectorAll('.message-body');

        messages.forEach(function (message) {
            textToLinks(message);
        });
    }
}